<template>
  <div>
    <!-- Footer -->
    <footer class="page-footer font-small mdb-color lighten-3">
      <hr />
      <!-- Footer Links -->
      <div class="container text-center text-md-left">
        <!-- Grid row -->
        <div class="row">
          <!-- Grid column -->
          <div class="col-md-4 col-lg-3 mr-auto my-md-4 my-0 mt-4 mb-1">
            <!-- Content -->
            <h5 class="font-weight-bold text-uppercase mb-4">
              NEARCODE Consulting
            </h5>
            <p>Copyright {{ currentYear }}</p>
            <p>{{ this.contents.find(content => content.id_content === 163)?.title }}</p>
          </div>
          <!-- Grid column -->

          <hr class="clearfix w-100 d-md-none" />

          <!-- Grid column -->
          <div class="col-md-4 col-lg-4 mx-auto my-md-4 my-0 mt-4 mb-1">
            <!-- Links -->
            <ul class="list-unstyled">
              <li>
                <h5>
                  <router-link to="/contacts" id="privacity"
                    >{{ this.contents.find(content => content.id_content === 164)?.title }}</router-link
                  >
                </h5>
              </li>
              <li>
                <h5>
                  <router-link to="/privacity" id="privacity"
                    >{{ this.contents.find(content => content.id_content === 165)?.title }}</router-link
                  >
                </h5>
              </li>
              <li>
                <h5>
                  <a href="mailto:geral@nearcodeconsulting.com" id="email"
                    >geral@nearcodeconsulting.com</a
                  >
                </h5>
              </li>
            </ul>
          </div>
          <!-- Grid column -->

          <!-- Grid column -->

          <hr class="clearfix w-100 d-md-none" />

          <!-- Grid column -->
          <div
            class="col-md-2 col-lg-2 d-flex justify-content-center text-center mx-auto my-4"
          >
            <div class="row" id="icons">
              <a
                href="https://www.facebook.com/nearcode/"
                class="linkedin"
                target="blank"
                ><i class="fa fa-facebook"></i
              ></a>
              <a
                href="https://www.linkedin.com/company/nearcode-consulting/"
                class="linkedin"
                target="blank"
                ><i class="fa fa-linkedin"></i
              ></a>
            </div>
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </div>
      <!-- Footer Links -->
    </footer>
    <!-- Footer -->
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  data: function() {
    return {
      contents: [],
    };
  },
  mounted() {
    this.getAllContent();
  },
  methods : {
    async getAllContent() {
      this.contents = [];
      try {
        await this.$store.dispatch("fetchContent");
        let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "pt";
        for (let i = 0; i < this.getContent.data.length; i++) {
          if (this.getContent.data[i].page === 6) {
            let content = {
              id_content: this.getContent.data[i].id_content,
              title: lang === "pt" ? this.getContent.data[i].title : this.getContent.data[i].title_en,
              description: lang === "pt" ? this.getContent.data[i].description : this.getContent.data[i].description_en,
              img: this.img,
            };
            this.contents.push(content);
          }
        }
      } catch (err) {
        this.$router.push({ name: "Error" });
      }
    }
  },
  computed: {
    ...mapGetters(["getContent"]),
    currentYear() {
      return new Date().getFullYear();
    }

  },
};
</script>

<style scoped>
footer {
  background-color: hsl(0, 0%, 53%);
  color: white;
}
hr {
  border: 4px solid;
  color: #f7941e;
}

#icons a {
  padding: 0px 5px 5px 0px;
}

#icons a i {
  line-height: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
#icons a i.fa-facebook {
  background-color: #2c80d3;
  color: white;
}
#icons a i.fa-linkedin {
  background-color: #0e76a8;
  color: white;
}
#privacity {
  color: white;
  text-decoration-line: underline;
  text-decoration-color: #f7941e;
}
#email {
  color: white;
  text-decoration-line: underline;
  text-decoration-color: #f7941e;
}
.col-centered {
  text-align: center;
}
@media (max-width: 1000px) {
  h5 {
    font-size: 16px;
  }
}
</style>
